import { memoize } from "@/fp";
import { Label } from "@/gql/types";
import { querifyArray } from "@/utils/url";
import axios from "axios";
import { apiCall } from "../api/ApiResult.model";

const get_employees_departments_name = apiCall<
  Record<string, string>,
  Record<string, string>
>("employee-dep-by-id", async (ids) => {
  const res = await axios.get(
    `/extproxy/integrations/object-departments?includeObjects=true&${querifyArray(
      { internalObjectIds: Object.keys(ids) }
    )}`
  );

  const deps = res.data.value.objectDepartments;

  return {
    success: true,
    value: deps.reduce((acc: any, dep: any) => {
      dep.objects.forEach((user: any) => {
        acc[user.internalObjectId] = dep.departmentName;
      });
      return acc;
    }, ids),
  };
});
export const EmployeesHelper = {
  get_employees_departments_name_async: async (
    ids: string[]
  ): Promise<Record<string, string>> => {
    const indexed_ids = ids.reduce((acc, id) => {
      acc[id] = "";
      return acc;
    }, {} as Record<string, string>);
    if (indexed_ids && Object.keys(indexed_ids).length > 0) {
      const res = await get_employees_departments_name(indexed_ids);
      if (res.success) {
        return res.value;
      } else {
        return indexed_ids;
      }
    } else return {};
  },
  get_single_employee_department: memoize(
    async (emp_id: string): Promise<string> => {
      const res = await get_employees_departments_name({ [emp_id]: "" });
      if (res.success) {
        return res.value[emp_id];
      } else {
        return "";
      }
    }
  ),
  get_department_from_labels(labels: Label[] = []): string {
    if (labels.length > 0) {
      const deps = labels.filter((f) => f.labelCategory === "Department");
      return deps.length > 0 ? deps[0].name! : "";
    } else {
      return "";
    }
  },
};
